import {
  Box,
  Flex,
  Image,
  forwardRef,
} from "@chakra-ui/react";
import { motion, isValidMotionProp } from "framer-motion";
import placeholder from "assets/images/placeholder.png";
import React from "react";

export const MotionBox = motion.custom(
  forwardRef((props, ref) => {
    const chakraProps = Object.entries(props)
      .filter(([key]) => !isValidMotionProp(key))
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    return <Box ref={ref} {...chakraProps} />;
  })
);
export const MotionFlex = motion.custom(
  forwardRef((props, ref) => {
    const chakraProps = Object.entries(props)
      .filter(([key]) => !isValidMotionProp(key))
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    return <Flex ref={ref} {...chakraProps} />;
  })
);

export const MotionImage = motion.custom(
  forwardRef((props, ref) => {
    const chakraProps = Object.entries(props)
      .filter(([key]) => !isValidMotionProp(key))
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    return (
      <Image
        ref={ref}
        fallbackSrc={placeholder}
        {...chakraProps}
      />
    );
  })
);
